import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/organizations')({
  component: () => <Navigate replace search to="/bo/organizations" />,
})
